// extracted by css-extract-rspack-plugin
export default {"container":"container-_gyrNI","iframe":"iframe-ZPjHBV"};